import React from 'react';
import {
    ChatBubbleLeftRightIcon,
    DocumentTextIcon,
    PlayCircleIcon
} from '@heroicons/react/24/outline';
import type { ResourceEntryKind } from '../utils/resourceIndex';

/**
 * One icon + tint per content type, shared by the search palette, the overview
 * hubs and the list rows so a "Guide" reads the same everywhere.
 */
const KIND_STYLES: Record<ResourceEntryKind, { icon: typeof DocumentTextIcon; tint: string }> = {
    faq: { icon: ChatBubbleLeftRightIcon, tint: 'bg-yellow-50 text-yellow-600' },
    document: { icon: DocumentTextIcon, tint: 'bg-blue-50 text-blue-600' },
    video: { icon: PlayCircleIcon, tint: 'bg-green-50 text-green-600' }
};

interface ResourceKindIconProps {
    kind: ResourceEntryKind;
    /** Tailwind size classes for the tile, e.g. `w-10 h-10`. */
    className?: string;
    iconClassName?: string;
}

export const ResourceKindIcon: React.FC<ResourceKindIconProps> = ({
    kind,
    className = 'w-8 h-8',
    iconClassName = 'w-4 h-4'
}) => {
    const { icon: Icon, tint } = KIND_STYLES[kind];
    return (
        <span
            className={`${className} ${tint} flex-shrink-0 rounded-lg flex items-center justify-center`}
        >
            <Icon className={iconClassName} />
        </span>
    );
};

export default ResourceKindIcon;
